module.exports = __webpack_public_path__ + "img/background.ea23f442.png";